import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../constants/common'

import { REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME } from './RequestArchivedPipelinesModal.constants'

export function getRequestArchivedPipelinesModalPreparedItems(items) {
  return (
    items?.map(item => ({
      ...item,
      category: item?.category ? { value: item.category } : null,
      title: item?.name,
    })) || EMPTY_LIST
  )
}

export function getRequestArchivedPipelinesModalItemsFromResponse(
  responseData
) {
  return {
    items: getRequestArchivedPipelinesModalPreparedItems(responseData),
  }
}

export function getRequestArchivedPipelinesModalTableColumns() {
  return {
    [REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.archived]: {
      index: 3,
      name: REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.archived,
      ordering_field: null,
      title: 'RequestProfile.ArchivedPipelinesModalColumnArchivedKey',
      visible: true,
      width: 210,
    },
    [REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.category]: {
      index: 1,
      name: REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.category,
      ordering_field: null,
      title: 'RequestProfile.ArchivedPipelinesModalColumnCategoryKey',
      visible: true,
      width: 260,
    },
    [REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.created]: {
      index: 2,
      name: REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.created,
      ordering_field: null,
      title: 'RequestProfile.ArchivedPipelinesModalColumnCreatedKey',
      visible: true,
      width: 210,
    },
    [REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.title]: {
      index: 0,
      name: REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME.title,
      ordering_field: null,
      title: 'RequestProfile.ArchivedPipelinesModalColumnPipelineKey',
      visible: true,
      width: 300,
    },
  }
}

export function getRequestArchivedPipelinesModalRestoreNotification(t) {
  return {
    id: 'restore-archived-pipeline-info',
    text: t('Request.ArchivedPipelinesModalRestoreNotificationKey'),
    type: NOTIFICATION_TYPE.info,
  }
}

export function getRequestArchivedPipelinesModalCanSelectOnlyOneNotification(
  t
) {
  return {
    id: 'can-select-only-one-pipeline',
    text: t('Request.ArchivedPipelinesModalCanSelectOnlyOneNotificationKey'),
    type: NOTIFICATION_TYPE.info,
  }
}
